import { SharedUiColorNameV2 } from '@/shared/ui/theming';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BrowserProvider } from '../../providers/browser.provider';
import { AdvizeoModalService } from '../../services/advizeo-modal.service';
import { DashboardExportPopoverComponent } from './components/dashboard-export-popover/dashboard-export-popover';
import type { ReportGenerationOneShotConfiguration } from './reports.interface';
import { ReportsService } from './services/reports.service';

@Injectable({
    providedIn: 'root'
})
export class ReportsFeatureService {
    private _router = inject(Router);
    private _advizeoModalService = inject(AdvizeoModalService);
    private _translateService = inject(TranslateService);
    private _browserProvider = inject(BrowserProvider);
    private _reportsService = inject(ReportsService);

    goToFeature() {
        this._router.navigate(['/', 'reports']);
    }

    requestDashboardReportExport(configuration: ReportGenerationOneShotConfiguration) {
        this._advizeoModalService
            .openAdvizeoModal(DashboardExportPopoverComponent, configuration)
            .afterClosed()
            .then(reportUrl => {
                if (reportUrl !== undefined) {
                    this._advizeoModalService.openDialog({
                        title: this._translateService.instant('PAGES.AUTOMATED_REPORTS.REPORT_READY_TITLE'),
                        message: this._translateService.instant('PAGES.AUTOMATED_REPORTS.REPORT_READY_MESSAGE'),
                        buttons: [
                            {
                                text: this._translateService.instant('BUTTONS.SEE_REPORT'),
                                onClick: () => {
                                    this._browserProvider.goTo(reportUrl as string);
                                },
                                color: SharedUiColorNameV2.PRIMARY
                            }
                        ]
                    });
                }
            });
    }

    getCurrentlyPrintingReportType$() {
        return this._reportsService.getCurrentlyPrintingReportType$();
    }
}
